(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Products"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.getElementById('CollectionCarouselSection-{{ section.id }}');
  if (!section) return;

  var track = section.querySelector('.collection-carousel-track');
  if (!track) return;

  var cards = track.querySelectorAll('.collection-carousel-card');
  if (!cards.length) return;

  var container = section.querySelector('.collection-carousel');
  if (!container) return;

  var productsPerView = parseInt(container.dataset.productsPerView) || 4;
  var source = container.dataset.source || 'collection';
  var manualCount = parseInt(container.dataset.manualCount || '0', 10);
  var isCarousel = container.classList.contains('collection-carousel--is-carousel');

  function setCardBasis() {
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;

    if (viewportWidth >= 750) {
      if (source === 'manual' && !isCarousel && manualCount > 0 && cards.length === manualCount) {
        // Option B: auto widths based on manual block count when not carousel
        var basis;
        if (manualCount === 1) {
          basis = '100%';
        } else if (manualCount === 2) {
          basis = '50%';
        } else if (manualCount === 3) {
          basis = '33.3333%';
        } else {
          basis = '25%';
        }
        cards.forEach(function(card) {
          card.style.flexBasis = 'calc(' + basis + ' - 12px)';
        });
      } else {
        // Default behaviour (collection fallback or carousel mode)
        cards.forEach(function(card) {
          card.style.flexBasis = 'calc(100% / ' + productsPerView + ' - 12px)';
        });
      }
    } else {
      // Mobile: 2 cards per view
      cards.forEach(function(card) {
        card.style.flexBasis = 'calc(50% - 8px)';
      });
    }
  }

  setCardBasis();
  window.addEventListener('resize', setCardBasis);

  var prev = section.querySelector('.collection-carousel-arrow--prev');
  var next = section.querySelector('.collection-carousel-arrow--next');

  function getScrollAmount() {
    var rect = cards[0].getBoundingClientRect();
    return rect.width + 16; // width + gap
  }

  if (prev) {
    prev.addEventListener('click', function() {
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });
  }

  if (next) {
    next.addEventListener('click', function() {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
